import SelectField from "../common/SelectField.js"

/** Compact per-branch agent picker for Admin/Accountant bulk receive. */
export default function HubAgentPickPanel({
  groups,
  hubAgentPick,
  onSelectAgent,
  compactSelect = true,
}) {
  if (!groups?.length) return null

  return (
    <div className="mb-2 sm:mb-3 px-2 py-1.5 sm:px-2.5 sm:py-2 bg-violet-50 rounded-lg border border-violet-200">
      <p className="text-[10px] sm:text-[11px] font-semibold text-violet-900 mb-1">
        Receiver agents · {groups.length} branch{groups.length === 1 ? "" : "es"}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-1 sm:gap-1.5">
        {groups.map((group) => {
          const pick = hubAgentPick[group.hubId] || {}
          const agents = pick.agents || []
          const branchTitle = `${group.label} (${group.shipments.length} GC${group.shipments.length === 1 ? "" : "s"})`

          return (
            <div
              key={group.hubId}
              className="flex items-center gap-1.5 min-w-0 rounded-md border border-violet-100 bg-white/90 px-1.5 py-1"
              title={branchTitle}
            >
              <span className="shrink-0 w-[38%] min-w-0 truncate text-[10px] sm:text-[11px] font-medium text-gray-800">
                {group.label}
                <span className="font-normal text-gray-400"> · {group.shipments.length}</span>
              </span>
              <div className="flex-1 min-w-0">
                {pick.loading ? (
                  <span className="text-[10px] text-gray-500">…</span>
                ) : agents.length === 0 ? (
                  <span className="text-[10px] text-red-600 truncate block">No agent</span>
                ) : agents.length === 1 ? (
                  <span className="text-[10px] sm:text-[11px] text-gray-800 truncate block">
                    {agents[0].name}
                  </span>
                ) : compactSelect ? (
                  <select
                    className="w-full h-7 min-h-0 px-1 text-[10px] sm:text-[11px] border border-gray-300 rounded-md bg-white focus:outline-none focus:border-violet-400"
                    value={pick.selectedUserId || ""}
                    onChange={(e) => onSelectAgent(group.hubId, e.target.value)}
                    aria-label={`Agent for ${group.label}`}
                  >
                    <option value="">Agent…</option>
                    {agents.map((a) => (
                      <option key={a.user_id} value={a.user_id}>
                        {a.name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <SelectField
                    label=""
                    value={pick.selectedUserId || ""}
                    onChange={(e) => onSelectAgent(group.hubId, e.target.value)}
                    options={[
                      { value: "", label: "Agent…" },
                      ...agents.map((a) => ({
                        value: a.user_id,
                        label: a.name,
                      })),
                    ]}
                  />
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
